<script>
import lazyLoadComponent from '@router/lazyload-component'
import Layout from '@layouts/main'
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxDelete } from '@utils/message-box'
import { notification } from '@utils/notification'

const initData = (type) => {
  return {
    title: '',
    alias: '',
    introtext: '',
    description: '',
    content: '',
    notice: '',
    images: [],
    helper_commission_type: '',
    commission_type: '',
    costPrice: null,
    state: 1,
    feature: '',
    storeIds: [],
    serviceIds: [],
    sizeIds: [],
    tagList: [],
  }
}

export default {
  page: {
    title: '服務項目',
    meta: [{ name: 'description', content: 'Prepaid List' }],
  },
  components: {
    Layout,
    BaseSteps: () => import('@components/BaseSteps'),
    // BaseInputFloatingLabel,
    // ImageUpload: () => lazyLoadComponent(import('../chat/components/FileUpload')),
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    type: {
      type: String,
      required: true,
    },
  },
  provide() {
    return {
      routerType: this.type,
    }
  },
  data() {
    const submitData = Object.assign({}, initData(), this.defaultValue, {
      description: this.defaultValue.description && this.defaultValue.description.replace(/<br\s\/>/g, ''),
      content: this.defaultValue.content && this.defaultValue.content.replace(/<br\s\/>/g, ''),
      notice: this.defaultValue.notice && this.defaultValue.notice.replace(/<br\s\/>/g, ''),
      // categoryIds: this.defaultValue.categoryIds ? this.defaultValue.categoryIds[0] : 2,
      // productId: this.defaultValue.productId ? this.defaultValue.productId : this.products[0].id,
    })
    return {
      cacheData: {},
      submitData,
      tryingToStore: false,
      tryingToRemove: false,
      parentCategoryId: null,
      parentCategoryIndex: 0,
      parentTagIndex: [],  
      tagList: [],
      tabList: [
        {
          title: '',
          name: 'info',
          component: () => lazyLoadComponent(import('./components/TabInfo')),
        },
        {
          title: '',
          name: 'price',
          component: () => lazyLoadComponent(import('./components/TabPrice')),
        },
        {
          title: '',
          name: 'image',
          component: () => lazyLoadComponent(import('./components/TabImage')),
        },
      ],
      activeTab: 'info',
      activeStep: 1,
      tryingNextStep: false,
      selectedPrices: [],
      returnRightTitle: '基本資訊',
      validateAddSave: true,
      tabIndex: 0,
      tabTitle: {
        tempService: ['基本設定', '價格設定', '服務項目圖片'],
        tempSpa: ['基本資訊', '相關服務', `${this.$t('service.SPA')}介紹圖片`],
        tempDaycare: ['基本設定', '價格設定', '服務項目圖片'],
      },
      hintDialogVisible: false,
    }
  },
  computed: {
    isEditMode() {
      return this.defaultValue.id
    },
    isService() {
      return this.$route.params.type !== 'addition'
    },
    templateRouter() {
      const typeRouter = {
        service: 'tempService',
        addition: 'tempService',
        spa: 'tempSpa',
        daycare: 'tempDaycare',
      }
      return typeRouter[this.type]
    },
    showDeleteBtn() {
      return ['addition'].includes(this.type)
    },
    onMarketSet() {
      return ['service', 'addition', 'daycare'].includes(this.type)
    },
  },
  watch: {
    activeTab(nvl, ovl) {
      let { title } = this.tabList.find((item) => item.name === nvl)
      this.returnRightTitle = title
      this.tabIndex = this.tabList.findIndex((item) => item.name === nvl)
    },
    submitData(nvl, ovl) {},
  },
  created() {
    try {
      const routerPath = this.$route.path
      this.tryToFetchList()

      if (this.isEditMode && this.templateRouter === 'tempService' && !routerPath.includes('addition')) {
        this.tabList.push({
          title: '',
          name: 'scheduleChangePrice',
          component: () => lazyLoadComponent(import('./components/TabScheduleChangePrice')),
        })
        this.tabTitle['tempService'].push('人員變價設定')
      }
      if (this.isEditMode && this.templateRouter === 'tempService') {
        this.findCategory()
      }
      if (!this.isService) {
        if (this.isEditMode) {
          this.$route.meta.title = '編輯加購項目'
        } else {
          this.$route.meta.title = '新增加購項目'
        }
      }
      if (this.isService) {
        if (this.isEditMode) {
          this.$route.meta.title = '編輯服務項目'
          // this.$store.commit('title/SET_TITLE', '編輯加購項目')
        } else {
          this.$route.meta.title = '新增服務項目'
          // this.$store.commit('title/SET_TITLE', '新增加購項目')
        }
      }
      this.setTabListTitle()
    } catch (error) {
      console.error(error.message)
    }
  },
  methods: {
    setTabListTitle() {
      this.tabList.forEach((item, index) => (item.title = this.tabTitle[this.templateRouter][index]))
    },
    /**
     * @description 勾選到的資料
     * @param {Array} selectedData
     */
    updateSelectedPrices(selectedData) {
      this.selectedPrices = []
      for (let i = 0, len = selectedData.length; i < len; i++) {
        this.selectedPrices.push(selectedData[i])
      }
    },
    setSubmitData() {
      const submitData = Object.assign({}, initData(), this.cacheData, {
        description: this.cacheData.description && this.cacheData.description.replace(/<br\s\/>/g, ''),
        content: this.cacheData.content && this.cacheData.content.replace(/<br\s\/>/g, ''),
        notice: this.cacheData.notice && this.cacheData.notice.replace(/<br\s\/>/g, ''),
      })
      this.submitData = submitData
    },
    /**
     * @description 儲存完之後，打這支重新撈取資料
     */
    async tryToFetchSingle() {
      this.cacheData = await this.$store.dispatch('product/fetchSingleServiceData', this.submitData.id)
      this.setSubmitData()
    },
    async onClickNextStep() {
      this.tryingNextStep = true
      try {
        if (this.activeStep === 1) {
          await this.$refs[this.tabList[this.activeStep - 1].name].validate()
        }
        if (this.activeStep === 2 && this.templateRouter === 'tempService') {
          const isPriceNone = this.$refs[this.tabList[this.activeStep - 1].name].isPriceNone
          if (isPriceNone) {
            await this.$confirm('尚有服務項目的價格為0，確定要繼續嗎？', '提示', {
              confirmButtonText: '確定',
              showCancelButton: true,
              type: 'warning',
              center: true,
            })
          }
        }
        if (this.activeStep === 2 && this.templateRouter === 'tempSpa') {
          const { serviceIds, storeIds } = this.submitData
          if (serviceIds.length === 0 || storeIds.length === 0) {
            this.$alert(`請選擇至少一間分店以及一個服務`, '無法執行下一步', {
              confirmButtonText: '確認',
              center: true,
            })
            return
          }
        }
        this.activeStep++
      } catch {
      } finally {
        this.tryingNextStep = false
      }
    },
    goBack() {
      this.activeStep--
    },
    /**
     * @description 驗證填的價錢是否ok
     */
    confirmPrice(obj) {
      const validateData = ['price', 'basePrice', 'serviceTime', 'bufferTime']
      const commissionValidateData = ['commission_value', 'helper_commission_value']

      const result = validateData.every((field) => {
        const value = parseInt(obj[field])
        return !isNaN(value) && value >= 0
      })
      const commissionResult = commissionValidateData.every((field) => {
        if (!obj[field]) return true
        const value = parseInt(obj[field])
        return !isNaN(value) && value >= 0
      })

      const validate = result && commissionResult
      this.validateAddSave = validate
      return validate
    },
    /**
     * @desciprion 組成要交出去的價錢
     */
    composeSubmitSize() {
      try {
        for (let i = 0, len = this.submitData['prices'].length; i < len; i++) {
          let confirmSta = this.confirmPrice(this.submitData['prices'][i])
          if (!confirmSta) break
          this.$set(this.submitData['prices'][i], 'sizeId', this.submitData['prices'][i].categoryId)
          this.$set(this.submitData['prices'][i], 'id', null)
          this.$set(this.submitData['prices'][i], 'prices', [
            {
              basePrice: this.submitData['prices'][i].basePrice,
              price: this.submitData['prices'][i].price,
              isFlexible: this.submitData['prices'][i].isFlexible,
              commission_value: this.submitData['prices'][i].commission_value,
              costPrice: this.changeCostPrice(this.submitData['prices'][i].costPrice),
              helper_commission_value: this.submitData['prices'][i].helper_commission_value,
            },
          ])
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    changeCostPrice(value) {
      if (value === '' || value === undefined) {
        return null
      } else {
        return value
      }
    },
    validateNextStep() {
      try {
        let confirmSta = true
        for (let i = 0, len = this.submitData['prices'].length; i < len; i++) {
          confirmSta = this.confirmPrice(this.submitData['prices'][i])
          if (!confirmSta) {
            this.notZeroAlert()
            break
          }
        }
        return confirmSta
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 組成新增的資料
     */
    composeSubmitDataBeforeSaveAdd() {
      try {
        this.$set(this.submitData, 'petCategoryId', this.parentCategoryId)
        this.$set(this.submitData, 'type', this.isService ? 'cosmetic' : 'cosmetic-add')
        this.$set(this.submitData, 'id', null)
        this.$set(this.submitData, 'buffertime', 0)
        this.$set(this.submitData, 'serviceTime', 0)
        this.composeSubmitSize()
        this.$set(this.submitData, 'sizes', this.submitData.prices)
        this.$set(this.submitData, 'tagIds', this.parentTagIndex)
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 組成修改儲存的資料(for service or addtion)
     */
    composeSubmitDataBeforeSaveEdit() {
      try {
        const petCategory = this.category.find((item) => item.categoryTitle === this.submitData.petCategoryTitle)
        this.$set(this.submitData, 'petCategoryId', petCategory.id)
        this.submitData.petSizes.forEach((item) => {
          if ('prices' in item) {
            this.$set(item, 'costPrice', this.changeCostPrice(item['prices'][0]['costPrice']))
          }
        })
        this.$set(this.submitData, 'sizes', this.submitData.petSizes)
        this.$set(this.submitData, 'tagIds', this.parentTagIndex)
      } catch (error) {
        console.error(error.message)
        this.$message.error(error.message)
      }
    },
    /**
     * @description 修正一些為null的值 or 空的值
     */
    fixNullValueInSubmitData() {
      this.$set(this.submitData, 'notice', this.submitData.notice ? this.submitData.notice : '')
      this.$set(this.submitData, 'introtext', this.submitData.introtext ? this.submitData.introtext : '')
      this.$set(this.submitData, 'content', this.submitData.content ? this.submitData.content : '')
      this.$set(this.submitData, 'helper_commission_type', this.submitData.commission_type) // 這邊先讓helper_commission_type 為commission_type，以後開放
    },
    notZeroAlert() {
      this.$message({
        type: 'error',
        message: `價格設定，各欄位皆需大於等於0`,
      })
    },
    /**
     * @description 驗證submitData
     */
    async validateSubmitData() {
      await this.validateCommissionType()
      await this.validateChangePrice()
    },
    /**
     * @description 驗證變價價錢
     */
    async validateChangePrice() {
      return new Promise((resolve, reject) => {
        const { customServicePrices } = this.submitData
        // 如果沒有變價直接resolve()
        if (!customServicePrices) {
          resolve()
        }
        if (customServicePrices.length > 0) {
          customServicePrices.forEach((customServicePrice) => {
            const { servicePrices } = customServicePrice
            servicePrices.forEach((servicePrice) => {
              const { price, commission_value, helper_commission_value } = servicePrice
              if (price === null || isNaN(price) || +price < 0) {
                reject(new Error('請輸入正確服務變價'))
              }
              if ((typeof commission_value === 'number' && commission_value < 0) || isNaN(+commission_value) || +commission_value < 0) {
                reject(new Error('請輸入正確抽成'))
              }
              if ((typeof helper_commission_value === 'number' && helper_commission_value < 0) || isNaN(+helper_commission_value) || +helper_commission_value < 0) {
                reject(new Error('請輸入正確抽成'))
              }
            })
          })
        }
        resolve()
      })
    },
    /**
     * @description 美容服務 -> 點選 一般服務or加購服務 各列之後的儲存
     */
    async tryToStore(type) {
      try {
        if (this.isEditMode && this.activeTab === 'info') {
          await this.$refs[this.activeTab][0].validate()
        }
        const todoType = {
          service: {
            apiUrl: 'product/storeServicePriceGroup',
            editModeCompose: this.composeSubmitDataBeforeSaveEdit,
            addModeCompose: this.composeSubmitDataBeforeSaveAdd,
          },
          addition: {
            apiUrl: 'product/storeAdditionalPriceGroup',
            editModeCompose: this.composeSubmitDataBeforeSaveEdit,
            addModeCompose: this.composeSubmitDataBeforeSaveAdd,
          },
          spa: {
            apiUrl: 'product/storeServiceSpaGroup',
            editModeCompose: () => {},
            addModeCompose: () => {},
          },
        }

        this.tryingToStore = true
        this.isEditMode ? todoType[this.type]['editModeCompose']() : todoType[this.type]['addModeCompose']()

        if (this.templateRouter === 'tempService') {
          this.fixNullValueInSubmitData()
          if (!this.validateAddSave) {
            this.notZeroAlert()
            this.validateAddSave = true
            return
          }
        }
        await this.validateSubmitData()
        /// 給一般服務or加購服務的一次性增加一堆
        // for(let i = 0 ; i < 50; i ++){
        //   this.submitData.title = `a${i}`
        //   this.submitData.description = `a${i}`
        //   await this.$store.dispatch(`${todoType[this.type]['apiUrl']}`, this.submitData)
        // }
        /// 給護理介紹的一次性增加一堆
        // for (let i = 0; i < 100; i++) {
        //   this.submitData.title = `a${i}`
        //   this.submitData.description = `a${i}`
        //   this.submitData.feature = `a${i}`
        //   await this.$store.dispatch(`${todoType[this.type]['apiUrl']}`, this.submitData)
        // }
        await this.$store.dispatch(`${todoType[this.type]['apiUrl']}`, this.submitData)
        if (!this.isEditMode) {
          messageStore('add')
          notification('一般服務', '排班人員', 'staff')
        } else {
          messageStore('edit')
        }
        if (type !== 'price') {
          this.hintDialogVisible = true
          // this.backToList()
        } else {
          if (this.isEditMode) {
            this.tryToFetchSingle()
          }
        }
      } catch (error) {
        console.error(error)
        this.$message.error(error.message)
      } finally {
        this.tryingToStore = false
      }
    },
    closeHintDialog() {
      this.hintDialogVisible = false
      this.backToList()
    },
    findCategory() {
      const id = this.defaultValue.petSizes[0].sizeId
      if (this.category.length > 0) {
        this.category.forEach((item) => {
          const ids = item.children.map((child) => child.id)
          if (ids.includes(id)) {
            this.parentCategoryId = item.id
          }
        })
      }
    },
    backToList() {
      this.$router.push({
        name: 'service',
        params: {
          type: this.type,
        },
      })
    },
    /**
     * @description 切換tab
     */
    async beforeTabSwitch(activeName, oldActiveName) {
      try {
        if (oldActiveName === 'info') {
          await this.$refs[this.activeTab][0].validate()
          if (!this.submitData.commission_type && this.type !== 'spa') {
            throw new Error('請選擇服務抽成設定')
          }
        }
      } catch (error) {
        console.error(error)
        this.$message.error(error.message)
        throw new Error('')
      }
    },
    async validateCommissionType() {
      return new Promise((resolve, reject) => {
        const { petSizes, commission_type, prices } = this.submitData

        const isValidValue = (value) => {
          if (!value && value !== 0) return true
          return !isNaN(+value) && +value >= 0
        }
        const isValidPercent = (value) => +value <= 100
        const isNullValue = (value) => value === null || value === '' || value === undefined || parseFloat(value) >= 0

        const validateSize = (size, titleKey, sizeKey) => {
          const { commission_value, costPrice, helper_commission_value } = size.prices ? size.prices[0] : size

          if (
            !isValidValue(commission_value) ||
            !isNullValue(costPrice) ||
            !isValidValue(helper_commission_value) ||
            (commission_type === '%' && (!isValidPercent(commission_value) || !isValidPercent(helper_commission_value)))
          ) {
            reject(new Error(`${size[titleKey]}${size[sizeKey]}：請填入正確抽成金額`))
          }
        }

        if (this.isEditMode) {
          if (this.type !== 'spa') petSizes.forEach((size) => validateSize(size, 'storeTitle', 'sizeTitle'))
        } else {
          prices.forEach((size) => validateSize(size, 'storeTitle', 'petSizeTitle'))
        }

        resolve()
      })
    },
    /**
     * @secription 上架下架商品
     */
    async onMarketOrSoldOut(type) {
      try {
        await this.$store.dispatch('product/onMarketorSoldOut', {
          state: type === 'onMarket' ? 1 : 0,
          ids: this.selectedPrices.map((item) => item.id),
          service_id: this.defaultValue.id,
        })

        this.$message({
          message: type === 'onMarket' ? '上架成功' : '下架成功',
          type: 'success',
        })
        this.tryToFetchSingle()
      } catch (error) {
        console.error(error.message)
        this.$message.error(error.message)
      }
    },
    async deleteSelected() {
      try {
        this.tryingToRemove = true
        if (this.defaultValue.id) {
          await messageBoxDelete('此服務項目')
          await this.$store.dispatch('product/serviceRemove', { ids: [this.defaultValue.id] })
          messageDelete()
          this.backToList()
        }
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingToRemove = false
      }
    },
    /**
     * @description 更新人員變價
     */
    updateChangePrice(nvl) {
      try {
        const validateNum = function(val) {
          if (isNaN(val)) {
            return null
          }
          // if (val < 0) {
          //   return 0
          // }
          return val
        }
        const customServicePrices = nvl.reduce((accu, cur) => {
          const selectPrice = cur.sizePrices.reduce((innerAccu, innerCur) => {
            if (innerCur.selectedStatus) {
              innerAccu.push({
                price: +innerCur.changePriceNumber,
                servicePriceId: innerCur.id,
                commission_value: validateNum(+innerCur.commission_value),
                helper_commission_value: validateNum(+innerCur.helper_commission_value),
              })
            }
            return innerAccu
          }, [])
          accu.push({
            scheduleItemId: cur.id,
            servicePrices: selectPrice,
          })
          return accu
        }, [])
        this.$set(this.submitData, 'customServicePrices', customServicePrices)
      } catch (error) {
        console.error(error.message)
      }
    },
    async tryToFetchList() {
      const res = await this.$store.dispatch('mixTag/mixTagSearch', {
        search: '',
        type: 'cosmetic',
        paginate: 0,
      })
      this.tagList = res.items
    },
    handleParentTagIndexUpdate(updatedTagIds) {
      this.parentTagIndex = updatedTagIds;  // 當選擇變更時，更新 parentTagIndex
    },
  },
}
</script>

<template>
  <Layout>
    <div style="margin-bottom:60px">
      <!-- 修改模式 -->
      <template v-if="isEditMode">
        <el-tabs v-model="activeTab" stretch :before-leave="beforeTabSwitch" type="border-card" class="isStyleBase">
          <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="tab.name"> </el-tab-pane>
        </el-tabs>
        <div :class="$style.upperBtn">
          <div>
            <el-page-header :content="returnRightTitle" @back="backToList"></el-page-header>
          </div>
          <div v-if="isEditMode && activeTab === 'price' && onMarketSet">
            <el-button class="is-round" :disabled="selectedPrices.length === 0" :class="$style['upperBtn__marketWidth']" @click="onMarketOrSoldOut('onMarket')">上架項目</el-button>
            <el-button class="is-round" :disabled="selectedPrices.length === 0" :class="$style['upperBtn__marketWidth']" @click="onMarketOrSoldOut('soldOut')"> 下架項目</el-button>
          </div>
        </div>
        <div v-for="(tab, index) in tabList" :key="index" :class="$style.componentStyle">
          <component
            :is="tab.component"
            v-show="index === tabIndex"
            :ref="tab.name"
            :default-value.sync="submitData"
            :category-index.sync="parentCategoryIndex"
            :category-id.sync="parentCategoryId"
            :products="products"
            :category="category"
            :template-type="templateRouter"
            :is-service="isService"
            :tag-list="tagList"
            :parentTagIndex="parentTagIndex"           
            @update:parentTagIndex="handleParentTagIndexUpdate" 
            @store="tryToStore"
            @update="tryToFetchSingle"
            @updateSelectedPrices="updateSelectedPrices"
            @updateChangePrice="updateChangePrice"
          />
        </div>
        <div :class="$style.footer">
          <el-button v-if="isEditMode && showDeleteBtn" class="is-round" type="danger" :loading="tryingToRemove" :disabled="tryingToRemove" @click="deleteSelected">刪除</el-button>
          <el-button class="is-round" @click="backToList">取消</el-button>
          <el-button
            class="is-round"
            type="primary"
            data-tour-step="5"
            data-tour-text="最後別忘記按下「完成」，完成此方案新增了唷！"
            :loading="tryingToStore"
            :disabled="tryingToStore"
            @click="tryToStore"
          >
            <BaseIcon v-if="!tryingToStore" name="check" />
            <span>{{ isEditMode ? '儲存' : '建立' }}</span>
          </el-button>
        </div>
      </template>
      <!-- 新增模式 -->
      <template v-else>
        <BaseSteps :active="activeStep" :list="tabList" />
        <div :class="$style['thisPageCardStyle']">
          <el-card :class="[$style['card-wrapper'], $style['card-inner']]">
            <keep-alive>
              <component
                :is="tabList[activeStep - 1].component"
                :ref="tabList[activeStep - 1].name"
                :default-value.sync="submitData"
                :category-index.sync="parentCategoryIndex"
                :category-id.sync="parentCategoryId"
                :is-service="isService"
                :tag-list="tagList"
                :parentTagIndex="parentTagIndex"
                :template-type="templateRouter"
                :products="products"
                :category="category"
                @update:parentTagIndex="handleParentTagIndexUpdate"            
                @store="tryToStore"
              />
            </keep-alive>
            <div :class="$style.footer">
              <el-button class="is-round" @click="backToList">取消</el-button>
              <el-button v-if="activeStep !== 1" class="is-round" @click="goBack">上一步</el-button>
              <el-button
                v-if="activeStep !== 3"
                class="is-round"
                data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步"
                type="primary"
                :loading="tryingNextStep"
                @click="onClickNextStep(activeStep)"
              >
                {{ `下一步` }}
              </el-button>
              <el-button
                v-if="activeStep === 3"
                class="is-round"
                type="primary"
                data-tour-step="5"
                data-tour-text="最後別忘記按下「完成」，完成此方案新增了唷！"
                :loading="tryingToStore"
                :disabled="tryingToStore"
                @click="tryToStore"
              >
                <BaseIcon v-if="!tryingToStore" name="check" />
                <span>{{ isEditMode ? '儲存' : '建立' }}</span>
              </el-button>
            </div>
          </el-card>
        </div>
      </template>
      <el-dialog title="提醒" :visible.sync="hintDialogVisible" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" top="0" width="30%">
        <div class="d-flex justify-content-center">
          <span>稍等一下，資料約在五分鐘後儲存完成</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="is-round" @click="closeHintDialog">我已了解</el-button>
        </span>
      </el-dialog>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';

.thisPageCardStyle {
  :global {
    .el-card.is-always-shadow {
      box-shadow: none;
    }

    .el-card__body {
      padding: 0 20px 20px;
    }
  }
}

.card-inner {
  :global {
    // .el-card.is-always-shadow {
    //   box-shadow: none;
    // }
    // .el-card__body {
    //   padding: 0 20px 20px;
    // }
  }
}

:global {
  .el-page-header {
    align-items: center;
    font-size: 22px;
  }

  .el-page-header__left {
    border: 1px solid $color-border-for-bg-white;
    border-radius: $border-radius;
    padding: 12px 24px;
    background-color: white;
  }
}

.upperBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px;

  &__marketWidth {
    width: 150px;
  }
}

.componentStyle {
  margin: 20px;
}
</style>
